<template>
<div v-if="Object.keys(invoice).length">
  <breadcrumb :crumbs="crumbs"></breadcrumb>
  <flash-message></flash-message>
  <div class="row">
    <modal-log v-bind:id="invoice.identifier"></modal-log>
      <div class="ls-float-right">
        <div class="col-md-12 col-xlg-12 col-lg-12">
          <div class="ls-float-right">
            <dropdown id="dropdown-nf" data-ls-module="dropdown" class="ls-dropdown ls-lg-margin-right">
            <a slot="trigger" href="javascript:void(0)" class="ls-btn-primary ls-no-margin ls-xs-margin-right ls-xs-margin-top">Nota Fiscal</a>
            <nav slot="list" class="ls-dropdown-nav" aria-hidden="true">
              <authorized-link tag="nfs">
                <a v-if="!taxInvoiceExists() || isCanceled()" @click="generateTaxInvoice()" role="option" aria-expanded="false" href="#">{{ $t('invoices.buttons.generate_tax_invoice')}}</a>
              </authorized-link>
              <a v-if="taxInvoiceExists()" @click="openTaxInvoice()" role="option" aria-expanded="false" href="#">{{ $t('invoices.buttons.open_tax_invoice')}}</a>
              <authorized-link tag="nfs">
                <a v-if="taxInvoiceExists() && !isCanceled()" @click="showModalCancelTaxInvoice()" role="option" class="ls-color-danger" aria-expanded="false" href="#">{{ $t('invoices.buttons.cancel_tax_invoice')}}</a>
              </authorized-link>
            </nav>
          </dropdown>
        </div>
         <div class="ls-float-right">
            <dropdown data-ls-module="dropdown" id="dropdown-payment" class="ls-dropdown" v-if="showPaymentButtom()">
            <a slot="trigger" href="javascript:void(0)" class="ls-btn-primary ls-no-margin ls-xs-margin-right ls-xs-margin-top">Pagamento</a>
            <nav slot="list" class="ls-dropdown-nav" aria-hidden="true">
              <a target="_blank" title="Acessar" v-bind:href="invoice.payment_url" v-if="invoice.status === 'awaiting_payment'">{{ $t('invoices.buttons.payment_link') }}</a>
              <a target="_blank" title="Emitir" @click.prevent="getBillet()" href="javascript:void(0)" v-if="invoice.status === 'awaiting_payment'">{{ $t('invoices.buttons.emit_billet') }}</a>
              <authorized-link tag="confirm_invoice">
                <a @click="showInvoiceConfirmationModal()" href="javascript:void(0)" v-if="invoice.status === 'awaiting_payment'">{{ $t('invoices.buttons.set_paid') }}</a>
              </authorized-link>
              <authorized-link tag="update_due_date_invoice ls-xs-margin-top">
                <a @click="showModalChangeCorpDueDate()" href="javascript:void(0)" v-if="invoice.status === 'awaiting_payment'">{{ $t('invoices.buttons.change_due_date')}}</a>
              </authorized-link>
              <a href="javascript:void(0)" @click.prevent="setResendPaymentData()" v-if="invoice.status === 'awaiting_payment'">{{ $t('contracts.show.send_payment_url') }}</a>
              <a target="_blank" title="Acessar" @click.prevent="showModalCancelation()" href="javascript:void(0)" v-if="invoice.status === 'awaiting_payment'">Cancelar</a>
              <a href="javascript:void(0)" v-if="invoice.status === 'paid'" @click.prevent="showModalReverse()">{{ $t('invoices.buttons.reverse_invoice') }}</a>
            </nav>
          </dropdown>
        </div>

      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-md-12 col-xs-12 ls-sm-margin-top ls-display-flex flex-wrap-wrap">
      <div class="col-md-8 col-xs-12 lg-md-margin-bottom-in-sm ls-xs-margin-top-in-sm">
        <div class="ls-box ls-sm-space ls-display-flex flex-wrap-wrap">
          <div class="col-lg-12 col-xs-12">
            <h4 class="ls-title-4 ls-sm-margin-bottom ls-no-padding">{{ $t('invoices.show.invoice_data') }}</h4>
          </div>
          <label class="ls-label col-xlg-2 col-lg-4">
            <b class="ls-label-text">{{ $t('invoices.attributes.identifier') }}</b>
            <p>{{ invoice.identifier }}</p>
          </label>
          <label class="ls-label col-xlg-2 col-lg-4">
            <b class="ls-label-text">{{ $t('invoices.attributes.code') }}</b>
            <p>{{ invoice.code }}</p>
          </label>
          <label class="ls-label col-xlg-2 col-lg-4">
            <b class="ls-label-text">{{ $t('invoices.attributes.contract') }}</b>
            <router-link class="link" v-if="invoice.contract_id" slot="button" title=""  :to="{ name: 'contract_details', params: { id: invoice.contract_id }}">{{ invoice.contract_id }}</router-link>
          </label>
          <label class="ls-label col-xlg-2 col-lg-4">
            <b class="ls-label-text">{{ $t('invoices.attributes.amount_due') }}</b>
            <p name="plan.description">{{ money.parseViewValue(invoice.amount_due) }}</p>
          </label>
          <label class="ls-label col-xlg-2 col-lg-4">
            <b class="ls-label-text">{{ $t('invoices.attributes.status') }}</b>
            <p>{{ $t('invoices.attributes.statuses.' + invoice.status) }}</p>
          </label>
          <label class="ls-label col-xlg-2 col-lg-4">
            <b class="ls-label-text">{{ $t('invoices.attributes.created_at') }}</b>
            <p name="plan.description">{{ date.parseDate(invoice.created_at) }}</p>
          </label>
          <label class="ls-label col-xlg-2 col-lg-4">
            <b class="ls-label-text">{{ $t('invoices.attributes.due_date') }}</b>
            <p name="plan.description">{{ date.parseDate(invoice.due_date) }}</p>
          </label>
          <label class="ls-label col-xlg-3 col-lg-4" v-if="invoice.paid_at">
            <b class="ls-label-text">{{ $t('invoices.attributes.paid_at') }}</b>
            <p>{{ date.parseDate(invoice.paid_at) }}</p>
          </label>
          <div class="col-lg-12 ls-sm-space ls-no-padding-top invoice-box">
            <div class="col-md-12 col-xs-12 col-xlg-12 ls-float-left ls-no-padding">
              <h4 class="ls-title-4">{{ $t('invoices.show.invoice_items') }}</h4>
            </div>
            <table v-if="invoice.invoice_items.length" class="ls-table ls-float-left ls-sm-space">
              <thead>
                <tr>
                  <th>{{ $t('invoices.details.description') }}</th>
                  <th>{{ $t('invoices.details.period') }}</th>
                  <th>{{ $t('invoices.details.label') }}</th>
                  <th>{{ $t('invoices.details.value') }}</th>
                </tr>
              </thead>
              <tbody>
              <tr v-for="(invoice_item, index) in activesInvoiceItems(invoice)">
                <td>{{ invoice_item.description }}</td>
                <td>{{ periodicity(invoice_item) }}</td>
                <td>{{ invoice_item.resource_label }}</td>
                <td>R$ {{ money.parseViewValue(invoice_item.price) }}</td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="col-md-4 col-xs-12 ls-display-flex flex-wrap-wrap align-itens-strech align-content-space-between">
        <div class="col-md-12 col-xs-12 ls-no-padding">
          <div class="ls-box ls-sm-space">
            <h4 class="ls-title-4 ls-md-margin-bottom">{{ $t('invoices.labels.customer_data') }}</h4>
            <div v-if="Object.keys(customer).length">
              <label class="ls-label col-xlg-6">
                <b class="ls-label-text">{{ $t('customers.show.name') }}</b>
                <p name="plan.description">{{ customer.name || '-' }}</p>
              </label>
              <label class="ls-label col-xlg-6">
                <b class="ls-label-text">{{ $t('customers.show.mail') }}</b>
                <p name="plan.description">{{ customer.email || '-' }}</p>
              </label>
              <label class="ls-label col-xlg-6">
                <b class="ls-label-text">{{ $t('customers.show.cpf') }}</b>
                <p name="plan.description">{{ customer.cpf || '-' }}</p>
              </label>
              <label class="ls-label col-xlg-6">
                <b class="ls-label-text">{{ $t('customers.show.cnpj') }}</b>
                <p name="plan.description">{{ customer.cnpj || '-' }}</p>
              </label>
              <div class="col-xlg-12">
                <p><router-link :to="{ name: 'customers_details', params: { id: customer.id } }" class="ls-float-right link" title="Início" role="menuitem">{{ $t('customers.show.details') }}<span class="ls-ico-shaft-right ls-xs-margin-left"></span></router-link></p>
              </div>
            </div>
            <div v-else>
              <h4 class="ls-title-5 ls-md-margin-bottom">{{ $t('invoices.alerts.no_data') }}</h4>
            </div>
          </div>
        </div>
        <div class="col-md-12 col-xs-12 ls-no-padding ls-md-margin-top">
          <authorized-link class="align-itens-strech" tag="show_invoice_orders">
            <div class="ls-box ls-sm-space lg-md-margin-bottom-in-sm">
              <h4 class="ls-title-4 ls-md-margin-bottom">{{ $t('invoices.labels.orders') }}</h4>
                <p v-if="orders.length"><a style="cursor: pointer;" @click="showOrdersModal()" title="Início" class="link" role="menuitem">{{ $t('invoices.labels.show_orders') }}</a></p>
              <h4 v-else class="ls-title-5 ls-md-margin-bottom">{{ $t('invoices.labels.no_orders') }}</h4>
            </div>
          </authorized-link>
        </div>
      </div>
    </div>
  </div>

  <modal-send-payment v-model="resendPaymentObjects"></modal-send-payment>
  <modal-cancelation v-model="modalCancelation"></modal-cancelation>
  <modal-reverse v-model="modalReverse"></modal-reverse>
  <modal-manual-confirmation v-model="manualConfirmationModal"></modal-manual-confirmation>
  <modal-change-corp-due-date v-model="modalChangeCorpDueDate"></modal-change-corp-due-date>
  <modal-cancel-tax-invoice v-model="modalCancelTaxInvoice"></modal-cancel-tax-invoice>
  <modal-orders v-model="ordersModal" ></modal-orders>
</div>
</template>
<script>
  import { mapActions, mapGetters, mapMutations } from 'vuex'
  import date from 'src/utils/date'
  import money from 'src/utils/money'
  import Breadcrumb from 'src/app/components/shareds/Breadcrumb'
  import ModalManualConfirmation from './components/ModalManualConfirmation'
  import ModalChangeCorpDueDate from './components/ModalChangeCorpDueDate'
  import ModalCancelTaxInvoice from './components/ModalCancelTaxInvoice'
  import ModalCancelation from './components/ModalCancelation'
  import ModalReverse from './components/ModalReverse'
  import Dropdown from 'src/app/components/shareds/dropdown/Dropdown'
  import ModalLog from './components/ModalLog'
  import ModalSendPayment from './components/ModalSendPayment'
  import ModalOrders from './components/ModalOrders'
  import pdf from '../../../utils/pdf'

  export default {
    name: 'ShowInvoice',
    components: { Breadcrumb, ModalManualConfirmation, ModalCancelation, ModalReverse, ModalOrders, ModalSendPayment, ModalChangeCorpDueDate, ModalLog, ModalCancelTaxInvoice, Dropdown },
    data () {
      return {
        manualConfirmationModal: { show: false },
        modalChangeCorpDueDate: { show: false },
        modalCancelTaxInvoice: { show: false },
        modalCancelation: { show: false },
        modalReverse: { show: false },
        resendPaymentObjects: { show: false },
        ordersModal: { show: false },
        invoiceId: this.$route.params.invoice_id,
        contractId: this.$route.params.contract_id,
        date: date,
        money: money,
        invoiceItems: {},
        contractPlan: {},
        crumbs: {
          'ico': 'ls-ico-docs',
          'section': this.$t('invoices.details.title'),
          'paths': {
            0: {
              'title': this.$t('invoices.list.title'),
              'path': '/invoices'
            },
            1: {
              'title': this.$t('invoices.details.title'),
              'path': ''
            }
          }
        }
      }
    },
    methods: {
      ...mapActions(['consultServiceTaxInvoice', 'createTaxInvoice', 'cancelTaxInvoice', 'loadInvoice', 'loadCustomer', 'recoverOrCreateBillet', 'confirmInvoice', 'loadOrdersByInvoice', 'updateInvoice']),
      ...mapMutations(['clearFlash', 'setInvoice']),
      getInvoice () {
        this.$loader.show()
        var params = { contract_id: this.contractId, invoice_id: this.invoiceId }
        this.loadInvoice(params).then(this.getDependencies)
      },
      showCorp () {
        return window.location.host.split('.')[0] === 'gateway'
      },
      showInvoiceConfirmationModal () {
        this.manualConfirmationModal.show = true
      },
      showModalChangeCorpDueDate () {
        this.modalChangeCorpDueDate.show = true
      },
      showModalCancelTaxInvoice () {
        this.modalCancelTaxInvoice.show = true
      },
      showModalCancelation () {
        this.modalCancelation.show = true
      },
      showModalReverse () {
        this.modalReverse.show = true
      },
      setResendPaymentData () {
        this.clearFlash()
        this.setInvoice(this.invoice)
        this.resendPaymentObjects.show = true
      },
      showOrdersModal () {
        this.ordersModal.show = true
        this.ordersModal.buttonVerify = this.invoice.status !== 'paid'
        this.ordersModal.orders = this.orders
      },
      openTaxInvoice () {
        if (this.invoice.service_tax_invoice.url_invoice) {
          return window.open(this.invoice.service_tax_invoice.url_invoice)
        }
        let params = { id: this.invoice.service_tax_invoice.id }
        this.clearFlash()
        this.$loader.show()
        this.consultServiceTaxInvoice(params).then(this.afterConsult)
      },
      afterConsult (response) {
        this.getInvoice()
        if (response.status === 404) {
          this.$loader.hide()
          return
        }
        let fileName = 'nf_fatura-#' + this.invoice.identifier + '.pdf'
        let data = response.data
        pdf.download(data, fileName)
        this.$loader.hide()
      },
      generateTaxInvoice () {
        this.clearFlash()
        this.$loader.show()
        let params = { invoice_id: this.invoice.identifier }
        this.createTaxInvoice(params).then(this.afterAction)
      },
      taxInvoiceExists () {
        if (this.invoice.service_tax_invoice) return true
        return false
      },
      isFailed () {
        return this.invoice.service_tax_invoice.status === 'error'
      },
      isCanceled () {
        return this.invoice.service_tax_invoice.status === 'canceled'
      },
      isIssued () {
        return this.invoice.service_tax_invoice.status === 'issued'
      },
      afterAction () {
        this.getInvoice()
        this.$loader.hide()
      },
      getBillet () {
        this.clearFlash()
        this.$loader.show()
        let params = { invoice_id: this.invoice.id, method: 'billet' }
        this.recoverOrCreateBillet(params).then(this.redirectToBillet)
      },
      redirectToBillet (response) {
        if (response.status === 200) {
          window.open(response.data.invoice.order.payment_url, '', 'resizable')
        }
        this.getOrders()
        this.$loader.hide()
      },
      getDependencies () {
        this.getCustomer()
        this.getOrders()
        this.$loader.hide()
      },
      getCustomer () {
        if (this.invoice.customer_id) {
          this.loadCustomer(this.invoice.customer_id)
        }
      },
      getOrders () {
        if (this.invoice.id) {
          this.loadOrdersByInvoice(this.invoice.id)
        }
      },
      showPaymentButtom () {
        if (this.invoice.status === 'awaiting_payment' || this.invoice.status === 'paid') return true
        return false
      },
      activesInvoiceItems (invoice) {
        return invoice.invoice_items.filter((item) => {
          return item.active === true
        })
      },
      periodicity (invoiceItem) {
        if (invoiceItem.till && invoiceItem.from) {
          return this.date.parseDate(invoiceItem.from) + ' - ' + this.date.parseDate(invoiceItem.till)
        } else {
          return '-'
        }
      }
    },
    mounted () {
      this.getInvoice()
    },
    computed: {
      ...mapGetters(['invoice', 'customer', 'orders']),
      popup () {
        return window.name === 'popup'
      }
    },
    watch: {
      invoice: function () {
        this.invoiceItems = this.invoice.invoice_items
        this.contractPlan = this.invoiceItems.filter(function (invoiceItem) {
          return invoiceItem.resource_type === 'ContractPlan'
        })[0]

        this.contractPlan = this.contractPlan || this.invoiceItems[0]
      }
    }
  }
</script>
<style>
  .only-margin-right {
    margin-top: 0px !important;
    margin-bottom: 0px !important;
    margin-left: 0px !important;
  }
  .invoice-box {
    height: 230px;
  }
  .display-inline-table {
    display: inline-table !important;
  }
  .flex-wrap {
    flex-wrap: wrap;
  }
  .justify-content-flex-end {
    justify-content: flex-end;
  }
  @media (min-width: 768px)
  {
    .sm-margin-right {
      margin-right: 8px !important;
    }
    .buttons-height {
      height: 100px !important;
    }
  }
  @media (max-width: 600px)
  {
    .column-reverse {
      flex-direction: column-reverse;
    }
    .display-block {
      display: block !important;
    }
    .md-margin-bottom {
      margin-bottom: 8px !important;
    }
  }
</style>



// WEBPACK FOOTER //
// Show.vue?37a5387e